export default "__VITE_ASSET__ywvnA8GC__"